module.exports = __webpack_public_path__ + "img/redRubin.f131479.png";